import NavBar from 'components/NavKit/NavBar'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import config from 'constants/config'
import HeaderBar from './HeaderBar'
import NavigationTertiaryHeader from './NavigationHeader/NavigationTertiaryHeader'
import StickyHeaderBar from './StickyHeaderBar'
import SubHeaderBar from './SubHeaderBar'

interface Props {
  stickySearch?: boolean
}

function HeaderMain(props: Props) {
  const { stickySearch } = props

  if (config.NAVKIT_NAVBAR_ENABLED) {
    return <NavBar />
  }

  return <>
    <CSSBreakpoint min="tablet">
      <NavigationTertiaryHeader />
    </CSSBreakpoint>
    {stickySearch && <StickyHeaderBar />}
    {!stickySearch && <HeaderBar />}
    <CSSBreakpoint min="tablet">
      <SubHeaderBar />
    </CSSBreakpoint>
  </>
}

export default HeaderMain
